import React from 'react';
import { Route } from 'react-router-dom';
import Loadable from './loadable';

export const renderRouter = (config) => {
  return Object.entries(config).map((item: any) => {
    const props: any = {
      exact: true,
      path: item[0]
    };
    props.component = Loadable(item[0], item[1]);
    return <Route {...props} key={props.path} />;
  });
};

export * from './config';
